import {
  createLocalizedPathnamesNavigation,
  Pathnames,
} from 'next-intl/navigation';

export const locales = [
  'pt-BR',
  'en-US',
  'hi-IN',
  'tr-TR',
  'th-TH',
  'fil-PH',
  'ar-PK',
  'vi-VN',
  'es-MX',
  'es-AR',
  'es-GT',
  'es-DO',
  'es-UY',
  'es-PE',
  'es-CO',
  'es-CR',
  'es-CL',
  'en-BD',
  'en-CA',
  'en-ZA',
  'ar-MA',
  'id-ID',
] as const;

export const localePrefix = 'always';

export const pathnames: Pathnames<typeof locales> = {
  '/cartao-de-credito': {
    'pt-BR': '/cartao-de-credito',
    'en-US': '/credit-card',
    'hi-IN': '/credit-card',
    'fil-PH': '/credit-card',
    'vi-VN': '/credit-card',
    'th-TH': '/credit-card',
    'ar-PK': '/credit-card',
    'tr-TR': '/credit-card',
    'es-MX': '/tarjeta-de-credito',
    'es-AR': '/tarjeta-de-credito',
    'es-GT': '/tarjeta-de-credito',
    'es-DO': '/tarjeta-de-credito',
    'es-UY': '/tarjeta-de-credito',
    'es-PE': '/tarjeta-de-credito',
    'es-CO': '/tarjeta-de-credito',
    'es-CR': '/tarjeta-de-credito',
    'es-CL': '/tarjeta-de-credito',
    'en-BD': '/credit-card',
    'en-CA': '/credit-card',
    'en-ZA': '/credit-card',
    'ar-MA': '/credit-card',
    'id-ID': '/credit-card',
  },
  '/cartao-de-credito/todos': {
    'pt-BR': '/cartao-de-credito/todos',
    'en-US': '/credit-card/all',
    'hi-IN': '/credit-card/all',
    'fil-PH': '/credit-card/all',
    'vi-VN': '/credit-card/all',
    'th-TH': '/credit-card/all',
    'ar-PK': '/credit-card/all',
    'tr-TR': '/credit-card/all',
    'es-MX': '/tarjeta-de-credito/todos',
    'es-AR': '/tarjeta-de-credito/todos',
    'es-GT': '/tarjeta-de-credito/todos',
    'es-DO': '/tarjeta-de-credito/todos',
    'es-UY': '/tarjeta-de-credito/todos',
    'es-PE': '/tarjeta-de-credito/todos',
    'es-CO': '/tarjeta-de-credito/todos',
    'es-CR': '/tarjeta-de-credito/todos',
    'es-CL': '/tarjeta-de-credito/todos',
    'en-BD': '/credit-card/all',
    'en-CA': '/credit-card/all',
    'en-ZA': '/credit-card/all',
    'ar-MA': '/credit-card/all',
    'id-ID': '/credit-card/all',
  },
  '/cartao-de-credito/[slug]': {
    'pt-BR': '/cartao-de-credito/[slug]',
    'en-US': '/credit-card/[slug]',
    'hi-IN': '/credit-card/[slug]',
    'fil-PH': '/credit-card/[slug]',
    'vi-VN': '/credit-card/[slug]',
    'th-TH': '/credit-card/[slug]',
    'ar-PK': '/credit-card/[slug]',
    'tr-TR': '/credit-card/[slug]',
    'es-MX': '/tarjeta-de-credito/[slug]',
    'es-AR': '/tarjeta-de-credito/[slug]',
    'es-GT': '/tarjeta-de-credito/[slug]',
    'es-DO': '/tarjeta-de-credito/[slug]',
    'es-UY': '/tarjeta-de-credito/[slug]',
    'es-PE': '/tarjeta-de-credito/[slug]',
    'es-CO': '/tarjeta-de-credito/[slug]',
    'es-CR': '/tarjeta-de-credito/[slug]',
    'es-CL': '/tarjeta-de-credito/[slug]',
    'en-BD': '/credit-card/[slug]',
    'en-CA': '/credit-card/[slug]',
    'en-ZA': '/credit-card/[slug]',
    'ar-MA': '/credit-card/[slug]',
    'id-ID': '/credit-card/[slug]',
  },
  '/emprestimo': {
    'pt-BR': '/emprestimo',
    'en-US': '/loan',
    'hi-IN': '/loan',
    'fil-PH': '/loan',
    'vi-VN': '/loan',
    'th-TH': '/loan',
    'ar-PK': '/loan',
    'tr-TR': '/loan',
    'es-MX': '/prestamo',
    'es-AR': '/prestamo',
    'es-GT': '/prestamo',
    'es-DO': '/prestamo',
    'es-UY': '/prestamo',
    'es-PE': '/prestamo',
    'es-CO': '/prestamo',
    'es-CR': '/prestamo',
    'es-CL': '/prestamo',
    'en-BD': '/loan',
    'en-CA': '/loan',
    'en-ZA': '/loan',
    'ar-MA': '/loan',
    'id-ID': '/loan',
  },
  '/emprestimo/todos': {
    'pt-BR': '/emprestimo/todos',
    'en-US': '/loan/all',
    'hi-IN': '/loan/all',
    'fil-PH': '/loan/all',
    'vi-VN': '/loan/all',
    'th-TH': '/loan/all',
    'ar-PK': '/loan/all',
    'tr-TR': '/loan/all',
    'es-MX': '/prestamo/todos',
    'es-AR': '/prestamo/todos',
    'es-GT': '/prestamo/todos',
    'es-DO': '/prestamo/todos',
    'es-UY': '/prestamo/todos',
    'es-PE': '/prestamo/todos',
    'es-CO': '/prestamo/todos',
    'es-CR': '/prestamo/todos',
    'es-CL': '/prestamo/todos',
    'en-BD': '/loan/all',
    'en-CA': '/loan/all',
    'en-ZA': '/loan/all',
    'ar-MA': '/loan/all',
    'id-ID': '/loan/all',
  },
  '/emprestimo/[slug]': {
    'pt-BR': '/emprestimo/[slug]',
    'en-US': '/loan/[slug]',
    'hi-IN': '/loan/[slug]',
    'fil-PH': '/loan/[slug]',
    'vi-VN': '/loan/[slug]',
    'th-TH': '/loan/[slug]',
    'ar-PK': '/loan/[slug]',
    'tr-TR': '/loan/[slug]',
    'es-MX': '/prestamo/[slug]',
    'es-AR': '/prestamo/[slug]',
    'es-GT': '/prestamo/[slug]',
    'es-DO': '/prestamo/[slug]',
    'es-UY': '/prestamo/[slug]',
    'es-PE': '/prestamo/[slug]',
    'es-CO': '/prestamo/[slug]',
    'es-CR': '/prestamo/[slug]',
    'es-CL': '/prestamo/[slug]',
    'en-BD': '/loan/[slug]',
    'en-CA': '/loan/[slug]',
    'en-ZA': '/loan/[slug]',
    'ar-MA': '/loan/[slug]',
    'id-ID': '/loan/[slug]',
  },
  '/blog': {
    'pt-BR': '/blog',
    'en-US': '/blog',
    'hi-IN': '/blog',
    'fil-PH': '/blog',
    'vi-VN': '/blog',
    'th-TH': '/blog',
    'ar-PK': '/blog',
    'tr-TR': '/blog',
    'es-MX': '/blog',
    'es-AR': '/blog',
    'es-GT': '/blog',
    'es-DO': '/blog',
    'es-UY': '/blog',
    'es-PE': '/blog',
    'es-CO': '/blog',
    'es-CR': '/blog',
    'es-CL': '/blog',
    'en-BD': '/blog',
    'en-CA': '/blog',
    'en-ZA': '/blog',
    'ar-MA': '/blog',
    'id-ID': '/blog',
  },
  '/quem-somos': {
    'pt-BR': '/quem-somos',
    'en-US': '/about-us',
    'hi-IN': '/about-us',
    'fil-PH': '/about-us',
    'vi-VN': '/about-us',
    'th-TH': '/about-us',
    'ar-PK': '/about-us',
    'tr-TR': '/about-us',
    'es-MX': '/conocenos',
    'es-AR': '/conocenos',
    'es-GT': '/conocenos',
    'es-DO': '/conocenos',
    'es-UY': '/conocenos',
    'es-PE': '/conocenos',
    'es-CO': '/conocenos',
    'es-CR': '/conocenos',
    'es-CL': '/conocenos',
    'en-BD': '/about-us',
    'en-CA': '/about-us',
    'en-ZA': '/about-us',
    'ar-MA': '/about-us',
    'id-ID': '/about-us',
  },
  '/contato': {
    'pt-BR': '/contato',
    'en-US': '/contact-us',
    'hi-IN': '/contact-us',
    'fil-PH': '/contact-us',
    'vi-VN': '/contact-us',
    'th-TH': '/contact-us',
    'ar-PK': '/about-us',
    'tr-TR': '/contact-us',
    'es-MX': '/contactanos',
    'es-AR': '/contactanos',
    'es-GT': '/contactanos',
    'es-DO': '/contactanos',
    'es-UY': '/contactanos',
    'es-PE': '/contactanos',
    'es-CO': '/contactanos',
    'es-CR': '/contactanos',
    'es-CL': '/contactanos',
    'en-BD': '/contact-us',
    'en-CA': '/contact-us',
    'en-ZA': '/contact-us',
    'ar-MA': '/contact-us',
    'id-ID': '/contact-us',
  },
  '/politica-de-privacidade': {
    'pt-BR': '/politica-de-privacidade',
    'en-US': '/privacy-policy',
    'hi-IN': '/privacy-policy',
    'fil-PH': '/privacy-policy',
    'vi-VN': '/privacy-policy',
    'th-TH': '/privacy-policy',
    'ar-PK': '/privacy-policy',
    'tr-TR': '/privacy-policy',
    'es-MX': '/privacy-policy',
    'es-AR': '/privacy-policy',
    'es-GT': '/privacy-policy',
    'es-DO': '/privacy-policy',
    'es-UY': '/privacy-policy',
    'es-PE': '/privacy-policy',
    'es-CO': '/privacy-policy',
    'es-CR': '/privacy-policy',
    'es-CL': '/privacy-policy',
    'en-BD': '/privacy-policy',
    'en-CA': '/privacy-policy',
    'en-ZA': '/privacy-policy',
    'ar-MA': '/privacy-policy',
    'id-ID': '/privacy-policy',
  },
  '/termos-de-uso': {
    'pt-BR': '/termos-de-uso',
    'en-US': '/terms-of-use',
    'hi-IN': '/terms-of-use',
    'fil-PH': '/terms-of-use',
    'vi-VN': '/terms-of-use',
    'th-TH': '/terms-of-use',
    'ar-PK': '/terms-of-use',
    'tr-TR': '/terms-of-use',
    'es-MX': '/terms-of-use',
    'es-AR': '/terms-of-use',
    'es-GT': '/terms-of-use',
    'es-DO': '/terms-of-use',
    'es-UY': '/terms-of-use',
    'es-PE': '/terms-of-use',
    'es-CO': '/terms-of-use',
    'es-CR': '/terms-of-use',
    'es-CL': '/terms-of-use',
    'en-BD': '/terms-of-use',
    'en-CA': '/terms-of-use',
    'en-ZA': '/terms-of-use',
    'ar-MA': '/terms-of-use',
    'id-ID': '/terms-of-use',
  },
};

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createLocalizedPathnamesNavigation({ locales, localePrefix, pathnames });
